import React from 'react';
import DepositBalanceCard from './components/DepositBalanceIndex.jsx';

const DepositBalance = () => <DepositBalanceCard />;

export default DepositBalance;
